export class Log {
    constructor(
        public id?: number,
        public value?: string,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/log/log.model.ts